// Exports
export default {
	"settings": "settings_+vI8B",
	"receiveByMail": "receiveByMail_UtFB4",
	"dialogContent": "dialogContent_jXugk",
	"content": "content_KMHmZ"
};
